<template>
  <div
    v-if="permissionInfo.is_show_followups"
    id="followup-module"
    class="followup-module"
    :class="{ isEnglish: $isEnglish }"
  >
    <!-- 设置回访提醒 -->
    <a-form-item
      v-if="permissionInfo.is_add_remind"
      :label="`${visitBackTip}：`"
      class="set-remind clearfix"
    >
      <div
        v-if="followup.remind.time"
        class="edit"
      >
        <div class="top">
          <span>{{ followup.remind.time }}</span>
          <span
            class="btn-text"
            @click="openSetRemind(followup.remind)"
          > {{ $t('message["1388"]') }}</span>
          <span
            class="btn-text"
            @click="clearRemind"
          >{{ $t('message["734"]') }}</span>
        </div>
        <p class="remind-content">
          {{ followup.remind.content }}
        </p>
      </div>
      <span
        v-else
        class="btn-text set-btn"
        @click="openSetRemind"
      >{{ $t('message["1008"]') }}</span>
    </a-form-item>
    <!-- 回访记录列表 -->
    <a-form-item
      :label="`${visitbackTitTxt}：`"
      class="list-box clearfix"
    >
      <p
        v-if="next_followup_time"
        class="tip"
      >
        {{ $t('message["1293"]') }}：{{ $moment(next_followup_time * 1000).format('YYYY-MM-DD HH:mm:ss') }}
      </p>
      <ul v-if="followup.list && followup.list.length">
        <li
          v-for="(item, index) in followup.list"
          :key="item.id"
        >
          <!-- 回访记录详情 -->
          <div
            class="followup-detail"
          >
            <div
              v-if="item.is_show_xiaoman"
              class="top clearfix"
            >
              <span
                v-if="item.is_show_xiaoman"
                class="assoc-btn btn-text"
                @click="assocFollowup(item, index)"
              >{{ '同步至小满' }}</span>
              <span
                v-if="item.is_synced_xiaoman"
                class="assoc-btn btn-text disabled"
              >{{ '已同步至小满' }}</span>
              <!-- 删除回访按钮 -->
              <span
                v-if="permissionInfo.is_del_followups"
                class="del-btn btn-text"
                @click="delFollowup(item, index)"
              >{{ $t('message["962"]') }}</span>
            </div>
            <div class="info clearfix">
              <span class="time fl">{{ moment(item.uptime * 1000).format(dateFormat) }}</span>
              <span class="name textOverflow fl">{{ item.truename }}</span>
              <!-- 删除回访按钮 -->
              <span
                v-if="permissionInfo.is_del_followups && !item.is_show_xiaoman"
                class="del-btn btn-text"
                @click="delFollowup(item, index)"
              >{{ $t('message["962"]') }}</span>
            </div>
            <div
              class="content"
            >
              {{ item.content }}
            </div>
          </div>
          <!-- 回访记录上传图片列表 -->
          <a
            v-for="(file, i) in item.pics"
            :key="i"
            class="file"
            @click="handleclickGallery(item.pics, i)"
          >{{ file.file_name }}</a>
          <!-- 回访记录操作按钮 -->
          <div
            v-if="permissionInfo.is_add_followups"
            class="operate-btns"
          >
            <span
              class="mesage"
              @click="toggleReply(item, index)"
            >
              <i class="iconfont iconpinglun" />{{ (item.replys && item.replys.length) || $t('message["449"]') }}
            </span>
          </div>
          <!-- 回访记录回复列表 -->
          <div
            class="replys-list"
            :class="{show: item.showReply}"
          >
            <div
              v-if="permissionInfo.is_add_followups"
              class="add-box clearfix"
            >
              <div
                class="input-wrap clearfix"
                :class="{ 'fold-input': item.fold }"
              >
                <span
                  ref="truename"
                  class="truename"
                >@{{ item.truename }}:</span>
                <a-input
                  v-model="item.newReply"
                  type="textarea"
                  :style="{'padding-left': item.trueNameWidth + 'px'}"
                  @focus="handleFocusReply(item)"
                />
              </div>
              <a-button
                v-if="!item.fold"
                type="primary"
                :disabled="item.newReply === '' || item.newReply === undefined"
                @click="handleNewReply(item)"
              >
                {{ $t('message["449"]') }}
              </a-button>
            </div>
            <ul v-if="item.replys">
              <li
                v-for="reply in item.replys"
                :id="`reply_${reply.id}`"
                :key="reply.id"
              >
                <div
                  class="reply-top clearfix"
                >
                  <span class="time fl">{{ moment(reply.addtime * 1000).format(dateFormat) }}</span>
                  <span class="name textOverflow fl">{{ reply.truename }}</span>
                  <!-- 删除回访回复按钮 -->
                  <span
                    v-if="permissionInfo.is_del_followups"
                    class="del-btn btn-text fr"
                    @click="handleDeleteReply(reply.id, item.id)"
                  >{{ $t('message["962"]') }}</span>
                </div>
                <div class="reply-content">
                  @{{ reply.rtruename }}:{{ reply.content }}
                </div>
                <div class="operate-btns">
                  <add-reply-popover
                    :data="{ followupid: item.id, replyid: reply.id, replytype: 2 , truename: reply.truename }"
                    @submit="addReply"
                  />
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div
        v-else
        class="fs-gray"
      >
        {{ $t('message["1547"]') }}
      </div>
    </a-form-item>
    <!-- 设置回访提醒弹窗 -->
    <set-remind-modal
      :visible.sync="showSetRemindModal"
      :data="followup.remind"
      :inquiry-id="inquiryId"
    />
    <!-- 新增回访 -->
    <add-visite-modal
      :visible.sync="showAddvisiteModal"
      :data="followup"
      :inquiry-id="inquiryId"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import SetRemindModal from './modal/SetRemindModal'
import AddVisiteModal from './modal/AddVisiteModal'
import AddReplyPopover from './modal/AddReplyPopover'
import { inquiryReplyFollowup } from '@/services/inqueryServices'
import eventBus from '@/lib/eventBus'

// const FROM_SOPURCE = 'notice'
export default {
  components: {
    SetRemindModal,
    AddVisiteModal,
    AddReplyPopover
  },
  data () {
    return {
      next_followup_time: '',
      dateFormat: 'YYYY-MM-DD HH:mm',
      showSetRemindModal: false,
      showAddvisiteModal: false,
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'followup'
    ]),
    ...mapGetters('inquery/detailData', ['permissionInfo', 'formData']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    followupid () {
      return this.$route.query.followupid
    },
    replyid () {
      return this.$route.query.replyid
    },
    visitbackTitTxt () {
      return this.$t('message["1694"]')
    },
    visitBackTip () {
      return this.$t('message["447"]')
    }
  },
  async created () {
    await this.getFollowupList()

    this.$bus.$on('getFollowupList', this.getFollowupList)
  },

  destroyed () {
    eventBus.$off('getFollowupList')
  },

  methods: {
    moment,
    ...mapActions('inquery/detailData', [
      'fetchFollowupList',
      'inquiryDelFollowup',
      'inquiryDelFollowupReply',
      'inquiryDelRemind',
      'followupSyncxiaoman'
    ]),
    async getFollowupList (newFollowupid) {
      const chain = await this.fetchFollowupList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .onSuccess((res = {}) => {
          let followupid = newFollowupid || this.followupid
          this.next_followup_time = res.extend && res.extend.next_followup_time
          if (this.followup.list && this.followup.list.length) {
            for (let index in this.followup.list) {
              let item = this.followup.list[index]
              if (parseInt(item.id) === parseInt(followupid)) {
                this.setShowReplyTrueNameWidth(item, index)
              }
              if (item.replys && item.replys.length) {
                this.$set(item, 'fold', true)
              }
            }
            let id = 'reply_' + this.replyid
            let $currReply = document.getElementById(id)
            setTimeout(() => {
              $currReply && $currReply.scrollIntoView(false)
            }, 30)
          }
        })
        .fetch()
    },
    addVisite () {
      this.showAddvisiteModal = true
    },
    openSetRemind () {
      this.showSetRemindModal = true
    },
    async clearRemind () {
      const chain = await this.inquiryDelRemind()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .onNetSuccess(raw => {
          this.followup.remind.time = ''
          this.followup.remind.content = ''
          // eventBus.$emit('fetchInquiryDetail')
        })
        .fetch()
    },
    toggleReply (item, index) {
      if (!item.showReply) {
        this.setShowReplyTrueNameWidth(item, index)
      } else {
        this.$set(item, 'showReply', false)
        if (item.replys && item.replys.length) {
          this.$set(item, 'fold', true)
        }
      }
    },
    setShowReplyTrueNameWidth (item, index) {
      if (this.permissionInfo.is_add_followups) {
        this.$set(item, 'showReply', true)
      }
      setTimeout(() => {
        let trueNameWidth = this.$refs.truename && this.$refs.truename && this.$refs.truename[index].offsetWidth
        this.$set(item, 'trueNameWidth', trueNameWidth + 8)
      }, 30)
    },
    handleFocusReply (item) {
      this.$set(item, 'fold', false)
    },
    handleNewReply (item) {
      const obj = {
        followupid: item.id,
        replytype: 1,
        content: item.newReply || ''
      }
      this.addReply(obj)
      item.newReply = ''
    },
    async addReply ({ followupid, replyid, replytype, content }) {
      let params = {
        inquiryid: this.inquiryId,
        followupid,
        replytype, // 1回复回访记录 2回复回访记录评论
        content
      }
      if (replytype === 2) {
        params.replyid = replyid
      }
      let chain = await inquiryReplyFollowup()
      chain
        .params(params)
        .onNetSuccess(res => {
          this.getFollowupList(followupid)
        })
        .fetch()
    },
    delFollowup (item, index) {
      this.$confirm({
        title: this.$t('message["492"]'),
        content: this.$t('message["442"]') + '？',
        okText: this.$t('message["915"]'),
        okType: 'danger',
        class: 'confirm-warn-modal',
        cancelText: this.$t('message["896"]'),
        onOk: async () => {
          // this.followup.list.splice(index, 1)
          const chain = await this.inquiryDelFollowup()
          chain
            .params({
              inquiryid: this.inquiryId,
              followupid: item.id
            })
            .onSuccess(res => {
              this.getFollowupList()
            })
            .fetch()
        }
      })
    },
    handleDeleteReply (replyid, followupid) {
      let delTextArr = this.$t('message["1888"]').split('|')
      let content = <div><span class="fs-orange">{ delTextArr[0] }</span>{ delTextArr[1] }</div>
      this.$confirm({
        title: this.$t('message["1889"]'), // '将删除该条回复'
        content,
        closable: true,
        okText: this.$t('message["962"]'), // '删除'
        okType: 'danger',
        cancelText: this.$t('message["896"]'), // '取消'
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.inquiryDelFollowupReply({
            inquiryid: this.inquiryId,
            id: replyid
          })
          chain.onSuccess(res => {
            this.getFollowupList(followupid)
          })
        }
      })
    },
    async assocFollowup (item, index) {
      if (item.is_synced_xiaoman) return
      if (this.confirmLoading) return

      this.confirmLoading = true
      let chain = await this.followupSyncxiaoman({
        inquiryid: this.inquiryId,
        followupid: item.id
      })
      chain
        .onSuccess(res => {
          item.is_synced_xiaoman = 1
          item.is_show_xiaoman = 0
          this.confirmLoading = false
        })
        .onNetSuccess(res => {
          this.confirmLoading = false
        })
    },
    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.followup-module ::v-deep {
  padding: 25px 0;
  .ant-form-item-label {
    width: 80px !important;
  }
  .ant-form-item-control-wrapper {
    padding-left: 80px;
  }
  .set-remind {
    .edit {
      .btn-text {
        margin-left: 16px;
      }
      .remind-content {
        color: $gray2;
        word-break: break-all;
      }
    }
  }
  .list-box {
    .tip {
      display: block;
      padding: 4px 0 20px;
      color: #ffab3b;
      line-height: 24px;
    }
    li {
      padding: 12px 8px 18px;
      line-height: 1;
      border-top: solid 1px $gray4;
    }
    .followup-detail {
      margin-bottom: 7px;
    }
    .top {
      margin-bottom: 12px;
      text-align: right;
    }
    .assoc-btn {
      margin-right: 8px;
    }
    .assoc-btn.disabled {
      opacity: .5;
      cursor: text;
    }
    .info {
      margin-bottom: 12px;
      line-height: 24px;
    }
    .name {
      width: 130px;
      margin: 0 8px;
    }
    .reply-top .name {
      width: 90px
    }
    .content {
      line-height: 24px;
      color: $gray2;
      word-break: break-all;
    }
    a.file {
      display: block;
      margin-bottom: 10px;
    }
    .operate-btns {
      height: 32px;
      line-height: 32px;
      margin-top: 12px;
      text-align: right;
      color: #d6d6d6;
      .iconfont {
        margin-right: 5px;
      }
      .mesage {
        cursor: pointer;
      }
    }
    .replys-list {
      display: none;
      padding: 16px;
      background-color: #f5f5f5;
      &.show {
        display: block;
      }
      .reply-top {
        margin-bottom: 12px;
        color: #333;
      }
      .reply-content {
        color: #666;
        line-height: 24px;
        word-break: break-all;
      }
    }
    .add-box {
      margin-bottom: 24px;
      .input-wrap {
        position: relative;
        // width: 278px;
        height: 72px;
        border: 1px solid #5077aa;
        border-radius: 2px;
        &.fold-input {
          height: 40px;
          border-color: #d6d6d6;
        }
        .truename {
          position: absolute;
          top: 12px;
          left: 8px;
          z-index: 2;
          color: #999;
        }
        .ant-input {
          width: 100%;
          height: 100%;
          padding: 8px;
          border-radius: 2px;
          border: none;
          resize: none;
        }
      }
      .ant-btn {
        float: right;
        width: 56px;
        height: 32px;
        margin-top: 8px;
        &.ant-btn[disabled] {
          color: #fff;
          background: linear-gradient(
            360deg,
            rgba(80, 119, 170, 1) 0%,
            rgba(96, 143, 204, 1) 100%
          );
          box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
          border: 1px solid rgba(80, 119, 170, 1);
          opacity: 0.8;
        }
      }
    }
  }
}
.isEnglish {
  .list-box .name {
    width: 123px;
  }
}
</style>
